import IconTile from '../../Icon/IconTile';

const SquareCheck = () => <IconTile name="checkSquare" />;

export { SquareCheck };
